import z from 'zod'

export const ProviderIdParams = z.object({
  providerId: z.string(),
})

export const ProviderUserManagementParams = ProviderIdParams
